/**
 * Query-string builder for bruktbil endpoints that take `merke[]`.
 *
 * FastAPI declares the param as `merke: List[str] = Query(alias="merke[]")`,
 * so the literal key in the URL must keep its brackets. Axios's serializer
 * strips them and the filter is then **silently ignored** — the request still
 * returns 200 with unfiltered data, which is why this is built by hand. Same
 * trap already documented in MerkeModell/api.ts and Priser/api.ts.
 */
export function buildBruktbilQs(
  p: Record<string, unknown>,
  merker: string[] = [],
): string {
  const qs = new URLSearchParams()
  for (const [key, value] of Object.entries(p)) {
    if (value == null || value === '') continue
    if (Array.isArray(value)) {
      for (const v of value) if (v != null && v !== '') qs.append(key, String(v))
    } else {
      qs.set(key, String(value))
    }
  }
  for (const m of merker) qs.append('merke[]', m)
  return qs.toString()
}
